// achievements
import CleanSheetsPlate from "../images/trophy/CleanSheetsPlate.png";
import DivisionEightPlate from "../images/trophy/DivisionEightPlate.png";
import DivisionFivePlate from "../images/trophy/DivisionFivePlate.png";
import DivisionFourPlate from "../images/trophy/DivisionFourPlate.png";
import DivisionOnePlate from "../images/trophy/DivisionOnePlate.png";
import DivisionSevenPlate from "../images/trophy/DivisionSevenPlate.png";
import DivisionSixPlate from "../images/trophy/DivisionSixPlate.png";
import DivisionThreePlate from "../images/trophy/DivisionThreePlate.png";
import DivisionTwoPlate from "../images/trophy/DivisionTwoPlate.png";
import GoldenBootPlate from "../images/trophy/GoldenBootPlate.png";
import GoldenGlovePlate from "../images/trophy/GoldenGlovePlate.png";
import MostAssistsPlate from "../images/trophy/MostAssistsPlate.png";
import MostHeadersPlate from "../images/trophy/MostHeadersPlate.png";
import MostInterceptsPlate from "../images/trophy/MostInterceptsPlate.png";
import MostPassesPlate from "../images/trophy/MostPassesPlate.png";
import MostTacklesPlate from "../images/trophy/MostTacklesPlate.png";
import vgcdOr from "../images/trophy/VGCdOr.png";
//  trophies wall
import bg from "../images/trophy-wall/bg.png";
import goldenBoot from "../images/trophy-wall/golden-boot.png";
import goldenGlove from "../images/trophy-wall/golden-glove.png";
import mostAssists from "../images/trophy-wall/most-assists.png";
import mostCleanSheets from "../images/trophy-wall/most-clean-sheets.png";
import mostHeaders from "../images/trophy-wall/most-headers.png";
import mostInterceptions from "../images/trophy-wall/most-interceptions.png";
import mostPasses from "../images/trophy-wall/most-passes.png";
import shelf from "../images/trophy-wall/shelf.png";
import topDefender from "../images/trophy-wall/top-defender.png";
import VGCdOr from "../images/trophy-wall/VGC-dOr.png";
import BestPasserFaded from "../images/trophy-wall/BestPasserFaded.png";
import MostCleanSheetsFaded from "../images/trophy-wall/MostCleanSheetsFaded.png";
import TopTacklerFaded from "../images/trophy-wall/TopTacklerFaded.png";
import MostInterceptsFaded from "../images/trophy-wall/MostInterceptsFaded.png";
import MostHeadersFaded from "../images/trophy-wall/MostHeadersFaded.png";
import MostAssistsFaded from "../images/trophy-wall/MostAssistsFaded.png";
import GoldenGloveFaded from "../images/trophy-wall/GoldenGloveFaded.png";
import GoldenBootFaded from "../images/trophy-wall/GoldenBootFaded.png";
import VGCdOrFaded from "../images/trophy-wall/VGC-dOr-faded.png";

export const achievements = {
  divisionEight: DivisionEightPlate,
  divisionFive: DivisionFivePlate,
  divisionFour: DivisionFourPlate,
  divisionOne: DivisionOnePlate,
  divisionSeven: DivisionSevenPlate,
  divisionSix: DivisionSixPlate,
  divisionThree: DivisionThreePlate,
  divisionTwo: DivisionTwoPlate,
  cleanSheets: CleanSheetsPlate,
  goldenBoot: GoldenBootPlate,
  goldenGlove: GoldenGlovePlate,
  mostAssists: MostAssistsPlate,
  mostHeaders: MostHeadersPlate,
  mostIntercepts: MostInterceptsPlate,
  mostPasses: MostPassesPlate,
  mostTackles: MostTacklesPlate,
  vgcdOr: vgcdOr,
  VGCdOrFaded: VGCdOrFaded,
};

export const trophyImages = {

  cleanSheets: mostCleanSheets,
  goldenBoot: goldenBoot,
  goldenGlove: goldenGlove,
  mostAssists: mostAssists,
  mostHeaders: mostHeaders,
  mostIntercepts: mostInterceptions,
  mostPasses: mostPasses,
  mostTackles: topDefender,

  vgcdOr: vgcdOr,
  bg: bg,
  shelf: shelf,

  VGCdOrFaded: VGCdOrFaded,
  BestPasserFaded: BestPasserFaded,
  MostCleanSheetsFaded: MostCleanSheetsFaded,
  TopTacklerFaded: TopTacklerFaded,
  MostInterceptsFaded: MostInterceptsFaded,
  MostHeadersFaded: MostHeadersFaded,
  MostAssistsFaded: MostAssistsFaded,
  GoldenGloveFaded: GoldenGloveFaded,
  GoldenBootFaded: GoldenBootFaded,

};
